import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import _typeof from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/typeof";
import Onview from '@tencent/vft-onview';

var _genKey = function () {
  var index = 0;
  return function () {
    return '' + index++;
  };
}();

function removeHttp(src) {
  if (!src) return src;

  if (_typeof(src) === 'object' && src.backgroundImage) {
    src.backgroundImage = src.backgroundImage.replace(/^http:/, '');
    return src;
  }

  if (typeof src === 'string') {
    return src.replace(/^http:/, '');
  }

  return src;
}

export default {
  install: function install(Vue) {
    function setImage(el) {
      if (el.tagName.toLowerCase() === 'img') {
        $(el).attr('src', $(el).data('img-url'));
      } else {
        $(el).css('background-image', 'url(' + $(el).data('img-url') + ')');
      }
    }

    var unBindExpose = [];

    function bind(el, binding) {
      var key = _genKey();

      $(el).data('img-key', key);
      $(el).data('img-url', removeHttp(binding.value));
      Vue.nextTick(function () {
        unBindExpose[key] = Onview(el, {
          once: true,
          offsetTop: -300,
          offsetLeft: -300
        }, setImage.bind(null, el));
      });
    }

    function unbind(el) {
      var key = $(el).data('img-key');
      unBindExpose[key] && unBindExpose[key]();
      delete unBindExpose[key];
    }

    Vue.directive('img', {
      bind: bind,
      update: function update(el, binding) {
        unbind(el);
        bind(el, binding);
      },
      unbind: unbind
    });
  }
};